import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'
import store from '@/store/store.js'

library.add(faPlusCircle)

@Component({
	components: {
		Loader,
	},
})
export default class Login extends Vue {
	form = {
		email: '',
		password: '',
	}

	submitLoading = false
	googleLoading = false
	errorMsg = ''

	openGoogle() {
		const url = process.env.VUE_APP_URL || 'http://192.168.10.10:8734'
		this.googleLoading = true
		window.open(url + '/api/login/google', '_self')
	}

	async submit() {
		if (!this.form.email || !this.form.password) return
		this.errorMsg = ''
		this.submitLoading = true
		const res = await api.post('/api/login/llac/', this.form)
		if (res.ok) {
			Object.assign(store.user, res.data)
			localStorage.setItem('user', JSON.stringify(res.data))

			const windowLocal: any = window
			windowLocal.dataLayer = windowLocal.dataLayer || []
			const user = store.user
			if (user && !user.isCollaborator) {
				const gtag = (...args: string[]) => {
					const windowLocal: any = window
					if (windowLocal.dataLayer) {
						windowLocal.dataLayer.push(args)
					}
				}

				windowLocal.gtag = gtag

				windowLocal.gtag('js', new Date().toString())
				windowLocal.gtag('config', 'G-JJ0ZRN8VDK')
			}

			let currentFullPath = localStorage.currentFullPath || '/'

			if (!currentFullPath || currentFullPath[0] !== '/') {
				currentFullPath = '/'
			}

			this.$router.push(currentFullPath || '/')
		} else {
			this.submitLoading = false
			if (res.cod === 'USUARIO_NAO_ENCONTRADO') {
				this.errorMsg = 'Email não encontrado'
			} else if (res.cod === 'SENHA_INCORRETA') {
				this.errorMsg = 'Senha incorreta'
			} else if (res.cod === 'USUARIO_BLOQUEADO') {
				this.errorMsg = 'Email Bloqueado'
			}
		}
	}
}
